var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { FormattedMessage, FormattedCurrency } from "@irati/utils/lang";
import { connect } from "@irati/store";
import { Body, H4, Label } from "@irati/ui/src/Typography";
import { Container, WalletIcon } from "./styled/WalletSpendBalance";
var WalletSpendBalance = /** @class */ (function (_super) {
    __extends(WalletSpendBalance, _super);
    function WalletSpendBalance() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WalletSpendBalance.prototype.render = function () {
        var _a = this.props, className = _a.className, wallet = _a.wallet, children = _a.children;
        var availableBalance = wallet.availableBalance, currency = wallet.currency;
        return (React.createElement(Container, { className: className },
            React.createElement(Body, { small: true, marginBottom: 3 },
                React.createElement(FormattedMessage, { id: "perks.walletSpendBalance.intro" })),
            React.createElement(Label, { display: "inline-block", color: "contrast" },
                React.createElement(FormattedMessage, { id: "perks.walletSpendBalance.balanceLabel" })),
            React.createElement(H4, { marginBottom: 3 },
                React.createElement(WalletIcon, { icon: "wallet" }),
                React.createElement(FormattedCurrency, { isCents: false, value: availableBalance, currency: currency })),
            children));
    };
    WalletSpendBalance.defaultProps = {
        className: null
    };
    return WalletSpendBalance;
}(PureComponent));
var mapStateToProps = function (_a) {
    var wallet = _a.wallet;
    return ({
        wallet: wallet
    });
};
export default connect(mapStateToProps)(WalletSpendBalance);
